import * as XLSX from 'xlsx';
declare global {
  interface Navigator {
    msSaveBlob: (blobOrBase64: Blob | string, filename: string) => void;
  }
}
export const exportToCSV = (
  filename: string,
  rows: any,
  headers: string[],
  module?: string,
): void => {
  const formatedName = filename.replaceAll('.', '_');

  const disclaimer = [
    { name: ' ' },
    {
      name: 'The data provided in this download reflects the information currently available in the BITE database.',
    },
    {
      name: 'While we strive to maintain comprehensive and accurate regulatory data, BITE makes no guarantees regarding the completeness or accuracy of the data.',
    },
    {
      name: 'BITE is not liable for any omissions, inaccuracies, or reliance on this data that may result in financial loss, revenue loss, or other damages to your organization.',
    },
    {
      name: 'Users are encouraged to independently verify the information before making business or compliance decisions',
    },
  ];

  if (!rows || !rows.length) {
    const csvContent = `sep=,\n${headers.join(',')}`;
    const blob = new Blob([ csvContent ], { type: 'text/csv;charset=utf-8;' });

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, formatedName);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', formatedName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  } else {
    let arr = [];
    if (module === 'monitor') {
      arr = rows?.map((row: any) => {
        return {
          name: row.field,
          row: row.row,
          dataset: row.dataSet,
          hits: row.hits,
        };
      });
    }
    if (module === 'score') {
      arr = rows?.map((row: any) => {
        return {
          name: row.name,
          scoreField: row.field[0],
          dataset: row.dataSet,
          module: row.module,
        };
      });
    }
    if (module === 'bulk') {
      arr = rows?.map((row: any) => {
        if (row) {
          return {
            field: row.field,
            row: row.row,
            dataset: row.dataSet,
            country: row['Source Country'],
            listName: row['List Name'],
          };
        }
      });
    }
    if (module === 'entity') {
      arr = rows?.map((row: any) => {
        return {
          name: row._source['Name of Entity'],
          entityCountry: row._source['Source Country'],
          listName: row._source['List Name'],
          govtAgency: row._source.Agency,
          addRemarks: row._source['Additional Remarks'],
          updateDate: row._source['Date Updated on BITE Platform'],
        };
      });
    }
    if (module === 'commodity') {
      arr = rows?.map((row: any) => {
        return {
          name: row._source['Product Name'],
          program: row._source['HS Code'],
          screeningListCountry: row._source['Source Country'],
          govtAgency: row._source.Agency,
          screeningListName: row._source['List Name'],
          updateDate: row._source['Date Updated on BITE Platform'],
        };
      });
    }

    // CYBER OPTIONS
    if (module === 'TradeAlerts') {
      arr = rows?.map((row: any) => {
        return {
          name: row._source['Product Name'],
          hsCode: row._source['HS Code'],
          listName: row._source['List Name'],
          updateDate: row._source['Date Updated on BITE Platform'],
        };
      });
    }

    if (module === 'CVE') {
      arr = rows?.map((row: any) => {
        return {
          name: row._source['CVE ID'],
          vendorProject: row._source['Vendor Project'],
          product: row._source.Product,
          vulnerabilityName: row._source['Vulnerability Name'],
          reqAction: row._source['Required Action'],
        };
      });
    }

    if (module === 'Markets') {
      arr = rows?.map((row: any) => {
        return {
          name: row._source['Market Name'],
          description: row._source.Description,
          website: row._source.Website,
          marketLocation: row._source['Market Location'],
        };
      });
    }
    if (module === 'Controls') {
      arr = rows?.map((row: any) => {
        return {
          name: row._source['CIS Control'],
          cisSubcontrol: row._source['CIS Subcontrol'],
          assetType: row._source['Asset Type'],
          secFunction: row._source['Security Function'],
        };
      });
    }

    // DATASETS MODULES ENTITIES
    if (module === 'biteList') {
      arr = rows?.map((row: any) => {
        return {
          name: row._source['Name of Entity'],
          entityCountry: row._source['Entity Country'],
          dateAdded: row._source['Date Added'],
          tradeDomain: row._source['Trade Domain'],
          reasonForListing: row._source['Additional Remarks'],
          invstNotes: row._source['Investigative Notes'],
        };
      });
    }
    if (module === 'pep') {
      arr = rows?.map((row: any) => {
        return {
          name: row._source['Name of Entity'],
          entityType: row._source['Entity Type'],
          refNumber: row._source['Reference Number'],
          srcInfoURL: row._source['Source Information URL'],
        };
      });
    }
    if (module === 'debarred') {
      arr = rows?.map((row: any) => {
        return {
          name: row._source['Name of Entity'],
          listName: row._source['List Name'],
          refNumber: row._source['Reference Number'],
          entityCountry: row._source['Entity Country'],
          stateOrProv: row._source['State / Province'],
          addRemarks: row._source['Additional Remarks'],
        };
      });
    }
    if (module === 'ffLabor') {
      arr = rows?.map((row: any) => {
        return {
          name: row._source['Name of Entity'],
          listName: row._source['List Name'],
          entityCountry: row._source['Entity Country'],
          reasonForListing: row._source['Additional Remarks'],
        };
      });
    }
    if (module === 'watchlist') {
      arr = rows?.map((row: any) => {
        return {
          name: row._source['Name of Entity'],
          program: row._source.Program,
          screeningListCountry: row._source['Source Country'],
          govtAgency: row._source.Agency,
          screeningListName: row._source['List Name'],
          addRemarks: row._source['Additional Remarks'],
        };
      });
    }
    if (module === 'countryRisk') {
      arr = rows?.map((row: any) => {
        return {
          name: row._source['Source Country'],
          listName: row._source['List Name'],
          addRemarks: row._source['Additional Remarks'],
        };
      });
    }

    // DATASETS MODULES COMMODITIES
    if (module === 'hsCodes') {
      arr = rows?.map((row: any) => {
        return {
          name: row._source['HS Code'],
          section: row._source.Section,
          chapter: row._source.Chapter,
          description: row._source['Product Name'],
        };
      });
    }
    if (module === 'regimes') {
      arr = rows?.map((row: any) => {
        return {
          name: row._source['HS Code'],
          product: row._source['Product Name'],
          regime: row._source.Agency,
          regulator: row._source['Source Country'],
          concern: row._source['Risk Country'],
        };
      });
    }
    arr = [ ...arr, ...disclaimer ];

    const separator = ',';
    const keys: string[] =
      arr && arr.length > 0 && arr[0] ? Object.keys(arr[0]) : [];
    let columHearders: string[];
    if (headers) {
      columHearders = headers;
    } else {
      columHearders = keys;
    }
    const csvContent = `sep=,\n${columHearders.join(separator)}\n${arr
      .map((row: any) => {
        return keys
          .map((k) => {
            let cell = row[k] === null || row[k] === undefined ? '' : row[k];
            cell =
              cell instanceof Date ?
                cell.toLocaleString() :
                cell.toString().replace(/"/g, '""');
            if (cell.search(/("|,|\n)/g) >= 0) {
              cell = `"${cell}"`;
            }
            return cell;
          })
          .join(separator);
      })
      .join('\n')}`;
    const blob = new Blob([ csvContent ], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) {
      // In case of IE 10+
      navigator.msSaveBlob(blob, formatedName);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', formatedName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
};
export const parseCSV = (fileName: string) => {
  const excelData = XLSX.readFile(fileName);
  return Object.keys(excelData.Sheets).map((header) => ({
    header: header,
    data: XLSX.utils.sheet_to_json(excelData.Sheets[header]),
  }));
};
